// import { useRef, useState } from "react";
import ReactPlayer from 'react-player';
// import 'video.js/dist/video-js.css';
// import 'videojs-youtube';
// import ImageNotFound from '../../images/homepage/Image_not_available.png';
import './style.video.scss';
interface Props {
    videoContent: any;
}
const Video = (props: Props) => {

    // const [showVideo, setShowVideo] = useState<boolean>(false);
    // const playerRef = useRef<any>(null);

    // Hàm thực hiện thay thế ảnh khi ảnh bị lỗi
    // const handleImageError = (e: any) => {
    //     e.target.onerror = null;
    //     e.target.src = ImageNotFound;
    // }

    // const handleShowVideo = () => {
    //     setShowVideo(true);
    // }

    // const handleCancel = () => {
    //     setShowVideo(false);
    // }

    // Hàm thực hiện đóng popup
    // const closePopup = () => {
    //     if (playerRef.current) {
    //         playerRef.current.getInternalPlayer().stopVideo();
    //     }
    //     setShowVideo(false);
    // };

    return (
        <>
            {/* <div className='video-item' onClick={handleShowVideo}>
                <div className='image-video-item' >
                    <img src={props.videoContent.imageContents[0] ? props.videoContent.imageContents[0] : ImageNotFound} alt="" onError={handleImageError} />
                </div>
                <div className='play-icon-and-length'>
                    <FaRegPlayCircle />
                </div>
            </div> */}
            <ReactPlayer
                className="video-items"
                url={props.videoContent.link}
                width={'100%'}
                controls={true}
                muted={true}
            // light={props.videoContent.imageContents[0] ? props.videoContent.imageContents[0] : ImageNotFound}
            // config={{
            //     youtube: {
            //         playerVars: {
            //             title: 0,
            //             showinfo: 0,
            //             controls: 0
            //         }
            //     }
            // }}
            />

            {/* <video width="320" height="240" controls>
                <source src={props.videoContent.link} type="video/mp4" />
                Your browser does not support the video tag.
            </video> */}
            {/* <Modal
                className="modal-video"
                open={showVideo}
                onOk={closePopup}
                onCancel={closePopup}
                footer={null}
                maskClosable={true}
                width='90%'

            >
                <ReactPlayer
                    url={props.videoContent.link}
                    controls={true}
                    ref={playerRef}
                    width='100%'
                    height='100%'
                    onEnded={handleCancel}
                />
            </Modal> */}
        </>
    )
}

export default Video
